"use client";

import { useEffect } from "react";

export default function PreviewScroll({ targetId }) {
  useEffect(() => {
    if (window.location.hash === `#${targetId}`) {
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [targetId]);

  return null;
}
